import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Divider } from 'antd';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { getRestaurant } from './../../reducers';
import LoadingPage from './../../components/LoadingPage';

class Home extends Component {
    render() {
        const { restaurant } = this.props;
        return (
            <div>
                {
                    restaurant ?
                        <Grid>
                            <Row>
                                <Divider>Reservas de la semana</Divider>
                                <Col>
                                    
                                </Col>
                            </Row>
                        </Grid>
                        :
                        <LoadingPage />
                }
            </div>
        );
    }
}

Home.propTypes = {
    restaurant: PropTypes.object,
};

const mapDispatchToPropsActions = dispatch => ({
    
});

const mapStateToProps = state => ({
    restaurant:  getRestaurant(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(Home));